export default __webpack_public_path__ + "static/media/phone.98c4815e.png";